import React, { useState, useMemo } from 'react'
import { CToast, CToastHeader, CToastBody } from '@coreui/react'
import { useToasterNotifications } from 'hooks/useToasterNotifications'

import { createContext } from 'react'

export const ToasterContext = createContext(null)

const ToasterProvider = ({ children }) => {
  const [toasts, setToasts] = useState([])

  const addToast = (notification) => {
    const id = Date.now()

    setToasts(prev => [...prev, { ...notification, id }])

    setTimeout(() => {
      setToasts(prev => prev.filter(t => t.id !== id))
    }, 5000)
  }

  const operatorRaw = localStorage.getItem('Administrativo_operator')
  const operator = useMemo(() => {
    try {
      return operatorRaw ? JSON.parse(operatorRaw) : null
    } catch {
      return null
    }
  }, [operatorRaw])

  useToasterNotifications(operator?.id, addToast)

  const contextValue = useMemo(
    () => ({ addToast }),
    []
  )

  return (
    <ToasterContext.Provider value={contextValue}>
      {children}

      <div
        style={{
          position: 'fixed',
          bottom: 0,
          right: 0,
          zIndex: 1050,
          display: 'flex',
          flexDirection: 'column-reverse',
          gap: '0.5rem',
          padding: '1rem',
          pointerEvents: 'none',
        }}
      >
        {toasts.map(toast => (
          <CToast key={toast.id} autohide>
            <CToastHeader closeButton>
              <strong className="me-auto">{toast.title}</strong>
            </CToastHeader>
            <CToastBody>{toast.message}</CToastBody>
          </CToast>
        ))}
      </div>
    </ToasterContext.Provider>
  )
}

export default ToasterProvider
